import { render, staticRenderFns } from "./compSendLog.vue?vue&type=template&id=cd08ee6c"
import script from "./compSendLog.vue?vue&type=script&lang=js"
export * from "./compSendLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports